import type { RouteRecordRaw } from 'vue-router';

export const notificationsRoute: RouteRecordRaw = {
  path: '/notifications',
  name: 'Notifications',
  component: () => import('./pages/NotificationsPage.vue'),
  meta: {
    layout: 'main',
    authorize: ({ isGranted }) => isGranted('st:core:ticket-notifications:list'),
  },
};

export const notificationSettingsRoute: RouteRecordRaw = {
  path: '/settings/notifications',
  name: 'NotificationSettings',
  component: () => import('./pages/NotificationSettingsPage.vue'),
  meta: {
    layout: 'main',
    // The same gate as the list it configures: an account with no notification
    // inbox has nothing here to switch.
    authorize: ({ isGranted }) => isGranted('st:core:ticket-notifications:list'),
  },
};
